import { useEffect, useRef } from 'react';

const GoogleAnalytics = () => {
  const initialized = useRef(false);
  
  // Initialize GA tracking only once
  useEffect(() => {
    if (!initialized.current && typeof window.gtag === 'function') {
      // Mark as initialized
      initialized.current = true;
      
      // Track initial page view
      window.gtag('config', 'G-7S8VED8M90', {
        page_path: window.location.pathname + window.location.search,
        'cookie_flags': 'SameSite=None;Secure'
      });
    }
  }, []);

  return null; // This component doesn't render anything
};

// Utility function for tracking events
export const trackEvent = (action, category, label, value) => {
  // Prevent tracking during development to avoid console spam
  if (process.env.NODE_ENV === 'development') {
    console.log('GA Event (dev only):', { action, category, label, value });
    return;
  }
  
  // Only call gtag if it exists
  if (typeof window.gtag === 'function') {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value
    });
  }
};

export default GoogleAnalytics; 